import { Control, Controller } from "react-hook-form";
import { AgentTablesEntry, TablesField } from "../TablesField";

export const TablesFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <TablesField
          tables={field.value as AgentTablesEntry[] | undefined}
          onTablesChange={field.onChange}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};
